// src/features/blogs/public/BlogDetail.jsx
import { useParams, Link } from 'react-router-dom';
import { useGetBlogBySlugQuery } from '../blogsApiSlice';

export default function BlogDetail() {
  const { slug } = useParams();
  const { data, isLoading, isError, error } = useGetBlogBySlugQuery(slug);

  if (isLoading) return <div className="mx-auto max-w-3xl px-4 py-8 text-gray-500">Loading…</div>;
  if (isError) return <div className="mx-auto max-w-3xl px-4 py-8 text-red-600">Error: {error?.data?.message ?? 'Not found'}</div>;
  if (!data) return null;

  // Handle normalized response from blogsApiSlice:
  // transformResponse for getBlogBySlug returns { ids: [...], entities: { id: blog } }
  // or the API might return the blog object directly. Normalize both cases.
  let blog = null;
  if (data?.entities && Array.isArray(data.ids) && data.ids.length > 0) {
    blog = data.entities[data.ids[0]];
  } else {
    blog = data; // assume data is the blog object already
  }
  if (!blog) return null;

  return (
    <article className="mx-auto max-w-3xl px-4 py-8">
      <div className="mb-6">
        <Link to="/blogs" className="text-sky-600 hover:underline">← Back to Blog</Link>
      </div>

      <h1 className="text-3xl font-semibold text-gray-900">{blog.title}</h1>
      <div className="mt-2 text-sm text-gray-500">
        {blog.publishedAt ? new Date(blog.publishedAt).toLocaleString() : '—'} • {blog.author ?? 'Editorial'}
      </div>

      {blog.coverImageUrl && (
        <img src={blog.coverImageUrl} alt={blog.title} className="mt-6 w-full rounded-2xl object-cover" />
      )}

      {blog.summary && <p className="mt-6 text-lg text-gray-700">{blog.summary}</p>}

      <div className="prose prose-neutral mt-6 max-w-none">
        {typeof blog.content === 'string' ? (
          <p className="whitespace-pre-wrap">{blog.content}</p>
        ) : null}
      </div>
    </article>
  );
}
